import { Box, Button, Flex, Icon, Image, Stack, Text } from "@chakra-ui/react";
import { CaretLeftIcon } from "@phosphor-icons/react";
import { useRouter } from "next/router";

const RouteViewer = ({ koppiProps, setIsRouteViewer, developmentId, phoneNumber }) => {
    const router = useRouter();

    return (
        <Stack position="relative">
            <Flex
                position="absolute"
                p={{ base: 3, md: 5 }}
                top={0}
                w="100%"
                h="10vh"
                justifyContent="space-between"
                alignItems="center"
            >
                <Flex gap={3} alignItems="center">
                    <Box
                        w="40px"
                        h="40px"
                        bg="#000000"
                        borderRadius="full"
                        boxShadow="inset 0px 0px 0px 2px #D3D3D3, 0px 3px 7px rgba(0, 0, 0, 0.6)"
                        alignContent="center"
                        cursor="pointer"
                        _hover={{ background: "gray.600" }}
                        onClick={(e) => {
                            e.preventDefault();
                            setIsRouteViewer(false);
                        }}
                    >
                        <Icon color="#FFFFFF" boxSize={9}>
                            <CaretLeftIcon />
                        </Icon>
                    </Box>
                    <Text display={{ base: "none", md: "initial" }}>Atrás</Text>
                </Flex>
                <Flex gap={3}>
                    {phoneNumber && (
                        <Button
                            bg="#00BF4D"
                            px={2}
                            textAlign="center"
                            fontWeight={400}
                            _hover={{ background: "#00BF4D99" }}
                            borderRadius="sm"
                            onClick={(e) => {
                                e.preventDefault();
                                window.open(`https://wa.me/${phoneNumber}`);
                            }}
                        >
                            <Image
                                src="https://boomerang.s3.us-east-2.amazonaws.com/assets/icons/whatsapp_icon.svg"
                                alt="whatsapp_icon"
                            />
                            <Text display={{ base: "none", md: "initial" }} color="#FFFFFF">
                                Envíar Whatsapp
                            </Text>
                        </Button>
                    )}
                    {developmentId && (
                        <Button
                            bg="#FFFFFF"
                            px={2}
                            textAlign="center"
                            borderWidth={1}
                            borderColor="#002B49"
                            fontWeight={400}
                            _hover={{ background: "#F0F0F0" }}
                            borderRadius="sm"
                            onClick={(e) => {
                                e.preventDefault();
                                window.open(`${router.asPath}/seleccion?code=${developmentId}`);
                            }}
                        >
                            <Text color="accent.500">Consulta unidades disponibles</Text>
                        </Button>
                    )}
                </Flex>
            </Flex>
            <Box mt="10vh" h="90vh">
                <iframe
                    src={koppiProps?.url}
                    sandbox="allow-same-origin allow-scripts"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                    width="100%"
                    height="100%"
                />
            </Box>
        </Stack>
    );
};

export default RouteViewer;
